import React from 'react'
import { NotebookPen } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import DebouncedTextarea from '../../../debounced_textarea'
import store from '../../../../state/store'

class LessonPlanNotes extends React.Component {

  onTutorNoteChange = (value) => {
    store.emit('tutoring_jobs:update_note', this.props.tutoring_job.id, {
      name: 'tutor',
      value: value
    })
  }

  onTutorPlacementNoteChange = (value) => {
    store.emit('tutoring_jobs:update_note', this.props.tutoring_job.id, {
      name: 'tutor_placement',
      value: value
    })
  }

  onTutorAvailabilityNoteChange = (value) => {
    store.emit('tutoring_jobs:update_note', this.props.tutoring_job.id, {
      name: 'tutor_availability',
      value: value
    })
  }

  onSupportNoteChange = (value) => {
    store.emit('tutoring_jobs:update_note', this.props.tutoring_job.id, {
      name: 'support',
      value: value
    })
  }

  render() {
    const notes = this.props.tutoring_job.notes

    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <NotebookPen className="size-4" />
            Notes
          </CardTitle>
        </CardHeader>
        <CardContent className="grid gap-7">
          <div className="grid gap-2">
            <Label>Note to Tutor (visible to tutors)</Label>
            <DebouncedTextarea value={notes.tutor} placeholder="" onChange={this.onTutorNoteChange}/>
          </div>
          <div className="grid gap-2">
            <Label>Note to Tutor Placement</Label>
            <DebouncedTextarea value={notes.tutor_placement} placeholder="" onChange={this.onTutorPlacementNoteChange}/>
          </div>
          <div className="grid gap-2">
            <Label>Tutor Availability and Communication Note</Label>
            <DebouncedTextarea value={notes.tutor_availability} placeholder="" onChange={this.onTutorAvailabilityNoteChange}/>
          </div>
          <div className="grid gap-2">
            <Label>Note to Support</Label>
            <DebouncedTextarea value={notes.support} placeholder="" onChange={this.onSupportNoteChange}/>
          </div>
        </CardContent>
      </Card>
    )
  }
}

export default LessonPlanNotes
